const auth_reducer = (state = {}, action) => {
    switch(action.type){
        case "LOGIN_USER":
            return {
                ...state, 
                user: action.payload.user,
                authorized: true
            }
        case "LOGOUT_USER":
            return {
                ...state, 
                user: null,
                authorized: false
            }
        default:
            return state;
    }
}

export default auth_reducer;